import { FormattedMessage } from 'react-intl'
import TutorialConnectorButton from '@components/TutorialConnectorButton/TutorialConnectorButton'
import CreateTokenButton from '@components/CreateTokenButton/CreateTokenButton'

import emptyImage from '@static/images/resource-list/no-items.jpg'
import './ProfileEmptyList.css'

export default function ProfileEmptyList({
  type
}: {
  type: 'connectors' | 'tokens'
}) {
  return (
    <>
      <div className="profile-empty-list">
        <img src={emptyImage} alt="" aria-hidden="true" />
        <h2>
          <FormattedMessage id={`${type}-empty-list.title`} />
        </h2>
        <p>
          <FormattedMessage id={`${type}-empty-list.text`} />
        </p>
        {type === 'connectors' ? (
          <TutorialConnectorButton />
        ) : (
          <CreateTokenButton />
        )}
      </div>
    </>
  )
}
